module.exports = __webpack_public_path__ + "media/images/area/feature/banner/pc/vi_hokkaido-cdc6a9b045af023b2c57ed43cea3f4b1.jpg";